export * from "ce/navigation/FocusStrategy";

import { IDE_TYPE, type IDEType } from "ee/IDE/Interfaces/IDETypes";
import { AppIDEFocusStrategy } from "ee/navigation/FocusStrategy/AppIDEFocusStrategy";
import { NoIDEFocusStrategy } from "ce/navigation/FocusStrategy/NoIDEFocusStrategy";
import { PackageFocusStrategy } from "ee/navigation/FocusStrategy/PackageFocusStrategy";
import { WorkflowFocusStrategy } from "ee/navigation/FocusStrategy/WorkflowFocusStrategy";

export const getIDEFocusStrategy = (type: IDEType) => {
  switch (type) {
    case IDE_TYPE.None:
      return NoIDEFocusStrategy;
    case IDE_TYPE.App:
      return AppIDEFocusStrategy;
    // Add EE cases below
    case IDE_TYPE.Package:
    case IDE_TYPE.UIPackage:
      return PackageFocusStrategy;
    case IDE_TYPE.Workflow:
      return WorkflowFocusStrategy;
    default:
      throw Error("Ide focus strategy not defined");
  }
};
